import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import Layout from '../views/layout/Layout'

export const constantRouterMap = [
  // {path: '/', component: () => import('../views/home/index')},
  {path: '/login',meta:{title:'登录',keepAlive: false},  component:resolve => require(['@/views/login/index'],resolve), hidden: true},
  {path: '/sign', meta:{title:'注册',keepAlive: false},component:resolve => require(['@/views/login/sign'],resolve), hidden: true},
  {path: '/404', meta:{title:'404',keepAlive: false},component:resolve => require(['@/views/404'],resolve), hidden: true},

  {
    path: '',
    component: Layout,
    redirect: '/home',
    meta: { title: '首页', icon: 'home' },
    children: [{
      path: 'home',
      name: 'home',
      component: resolve => require(['@/views/home/index'], resolve),
      super: true,
      meta: { title: '首页', icon: 'home' },
    }, {
      path: 'home/inform',
      name: 'inform',
      component: resolve => require(['@/views/home/inform'], resolve),
      super: true,
      hidden: true,
      meta: { title: '通知', keepAlive: false }
    }, {
      path: 'home/morelist',
      name: 'morelist',
      component: resolve => require(['@/views/home/morelist'], resolve),
      super: true,
      hidden: true,
      meta: { title: '自卖商品排行榜', keepAlive: false }
    }, {
      path: 'home/moreindustry',
      name: 'moreindustry',
      component: resolve => require(['@/views/home/moreindustry'], resolve),
      super: true,
      hidden: true,
      meta: { title: '行业商品排行榜', keepAlive: false }
    }, {
      path: 'home/moremachine',
      name: 'moremachine',
      component: resolve => require(['@/views/home/moremachine'], resolve),
      super: true,
      hidden: true,
      meta: { title: '机器排行榜', keepAlive: false }
    }]
  },
  {
    path: '/shop',
    component: Layout,
    redirect: '/shop/list',
    name: '',
    meta: { title: '商品管理', icon: 'shop' },
    children: [{
      path: 'list',
      name: 'list',
      component: resolve => require(['@/views/shop/list/index'], resolve),
      super: true,
      meta: {
        title: '商品列表',
        keepAlive: true, // 是否缓存
        scollTopPosition: 0 // 滚动条位置
      }
    },
    {
      path: 'itemadd',
      name: 'itemadd',
      component: resolve => require(['@/views/shop/itemadd/index'], resolve),
      super: true,
      meta: { title: '新增商品', keepAlive: false }
    },
    {
      path: 'librarys',
      name: 'librarys',
      component: resolve => require(['@/views/shop/librarys/index'], resolve),
      super: true,
      meta: {
        title: '商品库',
        keepAlive: true, // 是否缓存
        scollTopPosition: 0 // 滚动条位置
      }
    }, {
      path: 'dirindex',
      name: 'dirindex',
      component: resolve => require(['@/views/shop/list/dirindex'], resolve),
      super: true,
      hidden: true,
      meta: { title: '查看商品', keepAlive: false }
    }, {
      path: 'diramend',
      name: 'diramend',
      component: resolve => require(['@/views/shop/list/diramend'], resolve),
      super: true,
      hidden: true,
      meta: { title: '修改商品', keepAlive: false }
    }, {
      path: 'librarysview',
      name: 'librarysview',
      component: resolve => require(['@/views/shop/librarys/librarysview'], resolve),
      super: true,
      hidden: true,
      meta: { title: '查看商品信息', keepAlive: false }
    }, {
      path: 'libraryslead',
      name: 'libraryslead',
      component: resolve => require(['@/views/shop/librarys/libraryslead'], resolve),
      super: true,
      hidden: true,
      meta: { title: '商品导入', keepAlive: false }
    }, {
      path: 'goodstype',
      name: 'goodstype',
      super: true,
      component: resolve => require(['@/views/shop/shoptube/goodstype'], resolve),
      meta: { title: '商品类型', keepAlive: false }
    },
    {
      path: 'goodscategory',
      name: 'goodscategory',
      super: true,
      component: resolve => require(['@/views/shop/shoptube/goodscategory'], resolve),
      meta: { title: '新增分类', keepAlive: false }
    }, {
      path: 'goodsmanage',
      name: 'goodsmanage',
      super: true,
      component: resolve => require(['@/views/shop/shoptube/goodsmanage'], resolve),
      meta: { title: '商品库管理', keepAlive: true }
    }, {
      path: 'addgoodsmanage',
      name: 'addgoodsmanage',
      component: resolve => require(['@/views/shop/shoptube/addgoodsmanage'], resolve),
      super: true,
      hidden: true,
      meta: { title: '添加商品库商品', keepAlive: false }
    }, {
      path: 'viewgoodsmanage',
      name: 'viewgoodsmanage',
      component: resolve => require(['@/views/shop/shoptube/viewgoodsmanage'], resolve),
      super: true,
      hidden: true,
      meta: { title: '查看商品信息', keepAlive: false }
    }, {
      path: 'amendgoodsmanage',
      name: 'amendgoodsmanage',
      component: resolve => require(['@/views/shop/shoptube/amendgoodsmanage'], resolve),
      super: true,
      hidden: true,
      meta: { title: '修改商品信息', keepAlive: false }
    }]
  },
  {
    path: '/wmmp',
    component: Layout,
    redirect: '/wmmp/list',
    name: 'wmmp',
    meta: { title: '机器管理', icon: 'wmmp' },
    children: [{
      path: 'list',
      name: 'list',
      component: resolve => require(['@/views/wmmp/list/index'], resolve),
      super: true,
      meta: {
        keepAlive: true, // 是否缓存
        title: '机器列表',

        scollTopPosition: 0 // 滚动条位置
      }
    },
    {
      path: 'addwmmp',
      name: 'addwmmp',
      component: resolve => require(['@/views/wmmp/addwmmp/index'], resolve),
      super: true,
      meta: { title: '添加机器', keepAlive: false }
    }, {
      path: 'aisle',
      name: 'aisle',
      component: resolve => require(['@/views/wmmp/aisle/aisle'], resolve),
      super: true,
      meta: { title: '货道模板', keepAlive: true }
    }, {
      path: 'list/addlist',
      name: 'list/addlist',
      component: resolve => require(['@/views/wmmp/list/addlist'], resolve),
      super: true,
      hidden: true,
      meta: { title: '查看机器信息',}
    }, {
      path: 'list/amendlist',
      name: 'list/amendlist',
      component: resolve => require(['@/views/wmmp/list/amendlist'], resolve),
      super: true,
      hidden: true,
      meta: { title: '修改机器信息', keepAlive: false }
    }, {
      path: 'aisle/addaisle',
      name: 'aisle/addaisle',
      component: resolve => require(['@/views/wmmp/aisle/addaisle'], resolve),
      super: true,
      hidden: true,
      meta: { title: '新增模板', keepAlive: false }
    }, {
      path: 'aisle/viewaisle',
      name: 'aisle/viewaisle',
      component: resolve => require(['@/views/wmmp/aisle/viewaisle'], resolve),
      super: true,
      hidden: true,
      meta: { title: '查看模板', keepAlive: false }
    }, {
      path: 'aisle/amendaisle',
      name: 'aisle/amendaisle',
      component: resolve => require(['@/views/wmmp/aisle/amendaisle'], resolve),
      super: true,
      hidden: true,
      meta: { title: '修改模板', keepAlive: false }
    }, {
      path: 'machinetype',
      name: 'machinetype',
      component: resolve => require(['@/views/wmmp/machinetype/machinetype'], resolve),
      super: true,
      hidden: true,
      meta: { title: '机器型号管理', keepAlive: false }
    }, {
      path: 'renew',
      name: 'renew',
      component: resolve => require(['@/views/wmmp/renew/renew'], resolve),
      super: true,

      meta: { title: '续费管理', keepAlive: false }
    }]
  },
  {
    path: '/organization',
    component: Layout,
    redirect: '/organization/company',
    name: 'organization',
    meta: { title: '机构管理', icon: 'organization' },
    children: [{
      path: 'company',
      name: 'company',
      component: resolve => require(['@/views/organization/company/index'], resolve),
      super: true,
      meta: { title: '公司管理', keepAlive: true }
    }, {
      path: 'editcompany',
      name: 'editcompany',
      component: resolve => require(['@/views/organization/company/editcompany'], resolve),
      super: true,
      hidden: true,
      meta: { title: '编辑', keepAlive: false }
    }, {
      path: 'editsubsidiary',
      name: 'editsubsidiary',
      component: resolve => require(['@/views/organization/company/editsubsidiary'], resolve),
      super: true,
      hidden: true,
      meta: { title: '添加子公司', keepAlive: false }
    }, {
      path: 'viewcompany',
      name: 'viewcompany',
      component: resolve => require(['@/views/organization/company/viewcompany'], resolve),
      super: true,
      hidden: true,
      meta: { title: '查看子公司', keepAlive: false }
    }, {
      path: 'circuit',
      name: 'circuit',
      component: resolve => require(['@/views/organization/circuit/index'], resolve),
      super: true,
      meta: { title: '线路管理', keepAlive: false }
    }, {
      path: 'amendcircuit',
      name: 'amendcircuit',
      component: resolve => require(['@/views/organization/circuit/amendcircuit'], resolve),
      super: true,
      hidden: true,
      meta: { title: '修改线路', keepAlive: false }
    }, {
      path: 'addcircuit',
      name: 'addcircuit',
      component: resolve => require(['@/views/organization/circuit/addcircuit'], resolve),
      super: true,
      hidden: true,
      meta: { title: '新增线路', keepAlive: false }
    }, {
      path: 'pointtype',
      name: 'pointtype',
      component: resolve => require(['@/views/organization/shoptube/pointtype'], resolve),
      super: true,
      meta: { title: '点位类型管理', keepAlive: false }
    }, {
      path: 'pt',
      name: 'pt',
      component: resolve => require(['@/views/organization/pt/index'], resolve),
      super: true,
      meta: { title: '点位管理', keepAlive: false }
    }, {
      path: 'amendpt',
      name: 'amendpt',
      component: resolve => require(['@/views/organization/pt/amendpt'], resolve),
      super: true,
      hidden: true,
      meta: { title: '修改点位', keepAlive: false }
    }, {
      path: 'addpt',
      name: 'addpt',
      component: resolve => require(['@/views/organization/pt/addpt'], resolve),
      super: true,
      hidden: true,
      meta: { title: '新增点位', keepAlive: false }
    }, {
      path: 'principal',
      name: 'principal',
      component: resolve => require(['@/views/organization/principal/index'], resolve),
      super: true,
      meta: { title: '线路负责人', keepAlive: true }
    }, {
      path: 'viewprincipal',
      name: 'viewprincipal',
      component: resolve => require(['@/views/organization/principal/viewprincipal'], resolve),
      super: true,
      hidden: true,
      meta: { title: '查看负责人', keepAlive: false }
    }, {
      path: 'amendprincipal',
      name: 'amendprincipal',
      component: resolve => require(['@/views/organization/principal/amendprincipal'], resolve),
      super: true,
      hidden: true,
      meta: { title: '修改负责人', keepAlive: false }
    }, {
      path: 'addprincipal',
      name: 'addprincipal',
      component: resolve => require(['@/views/organization/principal/addprincipal'], resolve),
      super: true,
      hidden: true,
      meta: { title: '添加负责人', keepAlive: false }
    }, {
      path: 'supplier',
      name: 'supplier',
      component: resolve => require(['@/views/organization/supplier/index'], resolve),
      super: true,
      meta: { title: '供应商管理', keepAlive: true }
    }, {
      path: 'amendsupplier',
      name: 'amendsupplier',
      component: resolve => require(['@/views/organization/supplier/amendsupplier'], resolve),
      super: true,
      hidden: true,
      meta: { title: '修改供应商', keepAlive: false }
    }, {
      path: 'viewsupplier',
      name: 'viewsupplier',
      component: resolve => require(['@/views/organization/supplier/viewsupplier'], resolve),
      super: true,
      hidden: true,
      meta: { title: '查看供应商', keepAlive: false }
    }, {
      path: 'addsupplier',
      name: 'addsupplier',
      component: resolve => require(['@/views/organization/supplier/addsupplier'], resolve),
      super: true,
      hidden: true,
      meta: { title: '添加供应商', keepAlive: false }
    }, ]
  },
  {
    path: '/audit',
    component: Layout,
    redirect: '/audit/commodityaudit',
    name: 'audit',
    meta: { title: '审核中心', icon: 'user', keepAlive: false },
    children: [{
      path: 'commodityaudit',
      name: 'commodityaudit',
      component: resolve => require(['@/views/audit/commodityaudit'], resolve),
      super: true,
      meta: {
        title: '商品审核',
        keepAlive: false, // 是否缓存
        scollTopPosition: 0 // 滚动条位置
      }
    }, {
      path: 'commodityaudit/audit',
      name: 'commodityaudit/audit',
      component: resolve => require(['@/views/audit/spAudit'], resolve),
      super: true,
      hidden: true,
      meta: { title: '审核', keepAlive: false }
    }, {
      path: 'companyaudit',
      name: 'companyaudit',
      component: resolve => require(['@/views/audit/companyaudit'], resolve),
      super: true,
      meta: {
        title: '公司审核',
        keepAlive: false, // 是否缓存
        scollTopPosition: 0 // 滚动条位置
      }
    }, {
      path: 'companyaudit/audit',
      name: 'companyaudit/audit',
      component: resolve => require(['@/views/audit/gsAudit'], resolve),
      super: true,
      hidden: true,
      meta: { title: '审核', keepAlive: false }
    }, {
      path: 'lineprincipalaudit',
      name: 'lineprincipalaudit',
      component: resolve => require(['@/views/audit/lineprincipalaudit'], resolve),
      // super:true,
      meta: { title: '线路负责人审核', keepAlive: false }
    }, {
      path: 'lineprincipalaudit/audit',
      name: 'lineprincipalaudit/audit',
      component: resolve => require(['@/views/audit/xlAudit'], resolve),
      // super:true,
      // hidden:true,
      meta: {
        title: '查看审核',
        keepAlive: false, // 是否缓存
      }
    }, {
      path: 'supplieraudit',
      name: 'supplieraudit',
      component: resolve => require(['@/views/audit/supplieraudit'], resolve),
      super: true,
      meta: {
        title: '供应商审核',
        keepAlive: false, // 是否缓存
        scollTopPosition: 0 // 滚动条位置
      }
    }, {
      path: 'supplieraudit/audit',
      name: 'supplieraudit/audit',
      component: resolve => require(['@/views/audit/gysAudit'], resolve),
      super: true,
      hidden: true,
      meta: { title: '审核', keepAlive: false }
    }, {
      path: 'gathering',
      name: 'gathering',
      component: resolve => require(['@/views/audit/gathering'], resolve),
      super: true,
      meta: {
        title: '收款配置审核',
        keepAlive: false, // 是否缓存
        scollTopPosition: 0 // 滚动条位置
      }
    }, {
      path: 'gathering/audit',
      name: 'gathering/audit',
      component: resolve => require(['@/views/audit/gatheringAudit'], resolve),
      super: true,
      hidden: true,
      meta: { title: '审核', keepAlive: false }
    }]
  },
  {
    path: '/mallmanagement',
    component: Layout,
    redirect: '/mallmanagement/producttypes',
    name: 'mallmanagement',

    meta: { title: '商城管理', icon: 'machineMall' },
    children: [{
      path: 'producttypes',
      name: 'producttypes',
      component: resolve => require(['@/views/mallmanagement/producttypes'], resolve),
      super: true,
      meta: { title: '商品类型', keepAlive: false }
    },
    {
      path: 'marque',
      name: 'marque',
      component: resolve => require(['@/views/mallmanagement/marque'], resolve),
      super: true,
      meta: { title: '商品型号', keepAlive: false }
    },
    {
      path: 'brand',
      name: 'brand',
      component: resolve => require(['@/views/mallmanagement/brand'], resolve),
      super: true,
      meta: { title: '商品品牌', keepAlive: false }
    }, {
      path: 'catalogue',
      name: 'catalogue',
      component: resolve => require(['@/views/mallmanagement/catalogue'], resolve),
      super: true,
      meta: { title: '商品列表', keepAlive: false }
    }, {
      path: 'itemadd',
      name: 'itemadd',
      component: resolve => require(['@/views/mallmanagement/itemadd'], resolve),
      super: true,
      meta: { title: '新增商品', keepAlive: false }
    }, {
      path: 'catalogue/viewcatalogue',
      name: 'catalogue/viewcatalogue',
      component: resolve => require(['@/views/mallmanagement/viewcatalogue'], resolve),
      super: true,
      hidden: true,
      meta: { title: '查看', keepAlive: false }
    }, {
      path: 'catalogue/amendcatalogue',
      name: 'catalogue/amendcatalogue',
      component: resolve => require(['@/views/mallmanagement/amendcatalogue'], resolve),
      super: true,
      hidden: true,
      meta: { title: '修改', keepAlive: false }
    }, {
      path: 'coupon',
      name: 'coupon',
      component: resolve => require(['@/views/mallmanagement/coupon'], resolve),
      super: true,
      meta: { title: '优惠券', keepAlive: false }
    }, {
      path: 'coupon/viewcoupon',
      name: 'coupon/viewcoupon',
      component: resolve => require(['@/views/mallmanagement/viewcoupon'], resolve),
      super: true,
      hidden: true,
      meta: { title: '查看优惠券', keepAlive: false }
    }, {
      path: 'coupon/amendcoupon',
      name: 'coupon/amendcoupon',
      component: resolve => require(['@/views/mallmanagement/amendcoupon'], resolve),
      super: true,
      hidden: true,
      meta: { title: '修改优惠券', keepAlive: false }
    }]
  },
  {
    path: '/machineMall',
    component: Layout,
    redirect: '/machineMall/buymachine',
    name: 'buymachine',
    meta: { title: '机器商城', icon: 'machineMall' },
    children: [{
      path: 'buymachine',
      name: '',
      component: resolve => require(['@/views/machineMall/buymachine'], resolve),
      super: true,
      meta: { title: '购买机器', keepAlive: false }
    },
    {
      path: 'myorder',
      name: 'myorder',
      component: resolve => require(['@/views/machineMall/myorder'], resolve),
      super: true,
      meta: { title: '我的订单', keepAlive: false }
    },
    {
      path: 'coupon',
      name: 'coupon',
      component: resolve => require(['@/views/machineMall/coupon'], resolve),
      super: true,
      meta: { title: '优惠券', keepAlive: false }
    }, {
      path: 'viewmachine',
      name: 'viewmachine',
      component: resolve => require(['@/views/machineMall/viewmachine'], resolve),
      super: true,
      hidden: true,
      meta: { title: '机器详情', keepAlive: false }
    }, {
      path: 'confrimorder',
      name: 'confrimorder',
      component: resolve => require(['@/views/machineMall/confrimorder'], resolve),
      super: true,
      hidden: true,
      meta: { title: '确认订单', keepAlive: false }
    }, {
      path: 'viewmyorder',
      name: 'viewmyorder',
      component: resolve => require(['@/views/machineMall/viewmyorder'], resolve),
      super: true,
      hidden: true,
      meta: { title: '订单详情', keepAlive: false }
    }]
  },
  {
    path: '/dc',
    component: Layout,
    redirect: '/dc/datadisplay',
    name: 'dc',
    meta: { title: '数据中心', icon: 'dc' },
    children: [{
      path: 'datadisplay',
      name: 'datadisplay',
      component: resolve => require(['@/views/dc/datadisplay/datadisplay'], resolve),
      super: true,
      meta: { title: '数据展示', keepAlive: false }
    },
    {
      path: 'pointdata',
      name: 'pointdata',
      component: resolve => require(['@/views/dc/pointdata/pointdata'], resolve),
      super: true,
      meta: { title: '点位数据', keepAlive: false }
    },
    {
      path: 'itdata',
      name: 'itdata',
      component: resolve => require(['@/views/dc/itdata/itdata'], resolve),
      super: true,
      meta: { title: '机器数据', keepAlive: false }
    },
    {
      path: 'productdata',
      name: 'productdata',
      component: resolve => require(['@/views/dc/productdata/productdata'], resolve),
      super: true,
      meta: { title: '商品数据', keepAlive: false }
    }, {
      path: 'pointdata/viewpointdata',
      name: 'pointdata/viewpointdata',
      component: resolve => require(['@/views/dc/pointdata/viewpointdata'], resolve),
      super: true,
      hidden: true,
      meta: { title: '点位详情', keepAlive: false }
    }, {
      path: 'itdata/viewitdata',
      name: 'itdata/viewitdata',
      component: resolve => require(['@/views/dc/itdata/viewitdata'], resolve),
      super: true,
      hidden: true,
      meta: { title: '机器详情', keepAlive: false }
    }, {
      path: 'productdata/viewproductdata',
      name: 'productdata/viewproductdata',
      component: resolve => require(['@/views/dc/productdata/viewproductdata'], resolve),
      super: true,
      hidden: true,
      meta: { title: '商品详情', keepAlive: false }
    }]
  },
  {
    path: '/operation',
    component: Layout,
    redirect: '/operation',
    meta: { title: '运营管理', icon: 'operation' },
    children: [{
      path: '',
      name: 'operation',
      component: resolve => require(['@/views/operation/index'], resolve),
      super: true,
      meta: { title: '运营管理', icon: 'operation' }
    }, {
      path: 'editgive',
      name: 'editgive',
      component: resolve => require(['@/views/operation/editgive'], resolve),
      super: true,
      hidden: true,
      meta: { title: '修改买一赠一活动', keepAlive: false }
    }, {
      path: 'viewgive',
      name: 'viewgive',
      component: resolve => require(['@/views/operation/viewgive'], resolve),
      super: true,
      hidden: true,
      meta: { title: '查看买一赠一活动', keepAlive: false }
    }, {
      path: 'creategive',
      name: 'creategive',
      component: resolve => require(['@/views/operation/creategive'], resolve),
      super: true,
      hidden: true,
      meta: { title: '创建买一赠一活动', keepAlive: false }
    }, {
      path: 'edittie',
      name: 'edittie',
      component: resolve => require(['@/views/operation/edittie'], resolve),
      super: true,
      hidden: true,
      meta: { title: '修改组合优惠活动', keepAlive: false }
    }, {
      path: 'viewtie',
      name: 'viewtie',
      component: resolve => require(['@/views/operation/viewtie'], resolve),
      super: true,
      hidden: true,
      meta: { title: '查看组合优惠活动', keepAlive: false }
    }, {
      path: 'createtie',
      name: 'createtie',
      component: resolve => require(['@/views/operation/createtie'], resolve),
      super: true,
      hidden: true,
      meta: { title: '创建组合优惠活动', keepAlive: false }
    }, {
      path: 'edittax',
      name: 'edittax',
      component: resolve => require(['@/views/operation/edittax'], resolve),
      super: true,
      hidden: true,
      meta: { title: '修改满减优惠活动', keepAlive: false }
    }, {
      path: 'viewtax',
      name: 'viewtax',
      component: resolve => require(['@/views/operation/viewtax'], resolve),
      super: true,
      hidden: true,
      meta: { title: '查看满减优惠活动', keepAlive: false }
    }, {
      path: 'createtax',
      name: 'createtax',
      component: resolve => require(['@/views/operation/createtax'], resolve),
      super: true,
      hidden: true,
      meta: { title: '创建满减优惠活动', keepAlive: false }
    }]
  },
  {
    path: '/fault',
    component: Layout,
    redirect: 'fault/stats',
    name: 'fault',
    meta: { title: '故障监控', icon: 'fault' },
    children: [{
      path: 'stats',
      name: 'stats',
      component: resolve => require(['@/views/fault/stats'], resolve),
      super: true,
      meta: { title: '故障统计', keepAlive: false }
    }, {
      path: 'commonproblems',
      name: 'commonproblems',
      component: resolve => require(['@/views/fault/commonproblems'], resolve),
      super: true,
      meta: { title: '常见故障问题', keepAlive: false }
    }, {
      path: 'work',
      name: 'work',
      component: resolve => require(['@/views/fault/work'], resolve),
      super: true,
      meta: { title: '客诉处理', keepAlive: false }
    }]
  },
  {
    path: '/stock',
    component: Layout,
    redirect: '/stock/stocklist',
    name: 'stock',
    meta: { title: '备货补货', icon: 'stock' },
    children: [{
      path: 'stocklist',
      name: 'stocklist',
      component: resolve => require(['@/views/stock/stocklist/index'], resolve),
      super: true,
      meta: { title: '备货单', keepAlive: false }
    }, {
      path: 'stockrecord',
      name: 'stockrecord',
      component: resolve => require(['@/views/stock/stockrecord/index'], resolve),
      super: true,
      meta: {
        title: '补货记录',
        keepAlive: false, // 是否缓存
        scollTopPosition: 0 // 滚动条位置
      }
    }, {
      path: 'viewstock',
      name: 'viewstock',
      component: resolve => require(['@/views/stock/stockrecord/viewstock'], resolve),
      super: true,
      hidden: true,
      meta: { title: '补货记录详情', keepAlive: false }
    }, {
      path: 'commodityRecord',
      name: 'commodityRecord',
      component: resolve => require(['@/views/stock/commodityRecord/index'], resolve),
      meta: { title: '商品补货记录', }
    }, {
      path: 'replenishmentList',
      name: 'replenishmentList',
      component: resolve => require(['@/views/stock/replenishmentList/index'], resolve),
      meta: { title: '历史补货清单', }
    }]
  },
  {
    path: '/finance',
    component: Layout,
    redirect: '/finance/order',
    name: 'order',
    meta: { title: '财务中心', icon: 'finance' },
    children: [{
      path: 'order',
      name: '',
      component: resolve => require(['@/views/finance/order'], resolve),
      super: true,
      meta: { title: '订单列表'}
    }, {
      path: 'refund',
      name: 'refund',
      component: resolve => require(['@/views/finance/refund'], resolve),
      super: true,
      meta: { title: '退款审核' }
    }, {
      path: 'unsettledOrder',
      name: 'unsettledOrder',
      component: resolve => require(['@/views/finance/unsettledOrder'], resolve),
      super: true,
      meta: { title: '未成交订单' }
    }, {
      path: 'statements',
      name: 'statements',
      component: resolve => require(['@/views/finance/statements'], resolve),
      super: true,
      meta: { title: '财务报表' }
    }, {
      path: 'statements/customreports',
      name: 'customreports',
      component: resolve => require(['@/views/finance/customreports'], resolve),
      super: true,
      hidden: true,
      meta: { title: '自定义报表' }
    }, {
      path: 'statements/upOrder',
      name: 'upOrder',
      component: resolve => require(['@/views/finance/upOrder'], resolve),
      super: true,
      meta: { title: '补订单列表' }
    }, {
      path: 'statements/newlyUpOrder',
      name: 'newlyUpOrder',
      component: resolve => require(['@/views/finance/newlyUpOrder'], resolve),
      super: true,
      hidden: true,
      meta: { title: '新增补扣订单' }
    }, {
      path: 'statements/paperCoins',
      name: 'paperCoins',
      component: resolve => require(['@/views/finance/paperCoins'], resolve),
      meta: { title: '纸硬币记录' }
    }]
  },

  {
    path: '/pay',
    component: Layout,
    redirect: '/pay/receipt',
    name: 'receipt',
    meta: { title: '支付中心', icon: 'paycenter' },
    children: [{
      path: 'receipt',
      name: '',
      component: resolve => require(['@/views/pay/receipt/index'], resolve),
      super: true,
      meta: { title: '收款配置', keepAlive: false }
    }, {
      path: 'extras',
      name: 'extras',
      component: resolve => require(['@/views/pay/extras/index'], resolve),
      super: true,
      meta: { title: '附加功能', keepAlive: false }
    }]
  },
  {
    path: '/role',
    component: Layout,
    redirect: '/role/menus',
    name: 'role',
    meta: { title: '角色管理', icon: 'role' },
    children: [{
      path: 'menus',
      name: 'menus',
      component: resolve => require(['@/views/role/menus'], resolve),
      super: true,
      meta: { title: '菜单设置', keepAlive: false }
    }, {
      path: 'roleprivileges',
      name: 'roleprivileges',
      component: resolve => require(['@/views/role/roleprivileges'], resolve),
      super: true,
      meta: { title: '角色权限管理', keepAlive: false }
    }, {
      path: 'accountaccess',
      name: 'accountaccess',
      component: resolve => require(['@/views/role/accountaccess'], resolve),
      super: true,
      meta: { title: '账号权限管理', keepAlive: false }
    }]
  },
  {
    path: '/split',
    component: Layout,
    redirect: '/user/revamp',
    name: 'split',
    meta: { title: '分账管理', icon: 'machineMall',keepAlive: false },
    children: [{
      path: 'minutedebt',
      name: 'minutedebt',
      component: resolve => require(['@/views/organization/minutedebt/minutedebt'], resolve),
      super: true,

      meta: { title: '新增分账人', keepAlive: true },

    },{
      path: 'revamp',
      name: 'revamp',
      component: resolve => require(['@/views/organization/minutedebt/revamp'], resolve),
      hidden: true,
      super: true,
      meta: { title: '修改', keepAlive: false },
    },{
      path: 'examine',
      name: 'examine',
      component: resolve => require(['@/views/organization/minutedebt/examine'], resolve),
      hidden: true,
      super: true,
      meta: { title: '查看', keepAlive: false },
    },{
      path: 'subDetail',
      name: 'subDetail',
      component: resolve => require(['@/views/organization/minutedebt/subDetail'], resolve),
      hidden: true,
      super: true,
      meta: { title: '分账明细', keepAlive: false },
    },{
      path: 'particulars',
      name: 'particulars',
      component: resolve => require(['@/views/organization/minutedebt/particulars'], resolve),
      hidden: true,
      super: true,
      meta: { title: '分账明细详情', keepAlive: false },
    }, {
      path: 'particularsTwo',
      name: 'particularsTwo',
      component: resolve => require(['@/views/organization/minutedebt/particularsTwo'], resolve),
      hidden: true,
      super: true,
      meta: { title: '公司分账明细详情', keepAlive: false },
    },{
      path: 'subAccount',
      name: 'subAccount',
      component: resolve => require(['@/views/finance/subAccount'], resolve),
      super: true,

      meta: { title: '待分账订单',keepAlive: false }
    },{
      path: 'companySubDetail',
      name: 'companySubDetail',
      component: resolve => require(['@/views/organization/minutedebt/companySubDetail'], resolve),
      super: true,
      meta: { title: '公司分账明细', keepAlive: true },
    },]
  },
  {
    path: '/user',
    component: Layout,
    redirect: '/user/journal',
    name: 'user',
    meta: { title: '个人中心', icon: 'user' },
    children: [{
      path: 'journal',
      name: 'journal',
      component: resolve => require(['@/views/user/journal'], resolve),
      super: true,
      meta: { title: '日志管理', keepAlive: false }
    }, {
      path: 'install',
      name: 'install',
      component: resolve => require(['@/views/user/install'], resolve),
      super: true,
      meta: { title: '设置', keepAlive: false }
    }, {
      path: 'help',
      name: 'help',
      component: resolve => require(['@/views/user/help'], resolve),
      super: true,
      meta: { title: '帮助', keepAlive: false }
    }]
  },

]

export default new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js